import { getValidationMessages } from '@shared/services/error-handler/helpers';

export class ApiError extends Error {
    status: number;
    code: any;
    fields: any;
    context: any;
    properties: any;
    type: any;

    constructor(
        attributes,
        // eslint-disable-next-line no-unused-vars
        public url = undefined
    ) {
        super();

        this.name = 'ApiError';
        this.message = attributes.message;
        this.code = attributes.code;
        this.status = attributes.status;
        this.type = attributes.type;
        this.fields = attributes.fields;
        this.context = attributes.context;
        this.properties = attributes;
    }

    get validationErrorMessages() {
        return getValidationMessages({ fields: this.fields }) || [];
    }

    static instanceOf(test) {
        return test instanceof ApiError || test.name === 'ApiError';
    }
}

export class RequestAbortedError extends Error {
    url: string;

    constructor(url: string = undefined) {
        super();

        this.name = 'RequestAbortedError';
        this.message = 'Request aborted';
        this.url = url;
    }

    static instanceOf(test) {
        return test instanceof RequestAbortedError || test.name === 'RequestAbortedError';
    }
}
